export default "__VITE_ASSET__9664bcec__"